import React, { Component } from "react";
import { Dialog, DialogTitle, Button, DialogActions, DialogContent, TextField, FormControl, InputLabel, Select, MenuItem, Checkbox, FormControlLabel } from "@material-ui/core";
import "./ContactDialog.css";

export class ContactDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			ContactData: {},
			open: false,
		};

		this.onClose = this.onClose.bind(this);
		this.saveData = this.saveData.bind(this);
	}

	componentDidUpdate(prevProps) {
		if ((this.props.Contact.contacts_id !== prevProps.Contact.contacts_id && this.props.visible) || (this.props.visible !== prevProps.visible && this.props.visible)) {
			this.setState({ ContactData: this.props.Contact, open: true });
		}
	}

	async saveData() {
		var toSave = this.state.ContactData;
		toSave.buildings_id = this.props.BuildingsID;
		await fetch("Building/SaveContact", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify({ contactData: toSave }),
		});

		this.onClose();
	}

	dynamicOnChange = (event) => {
		var columnName = null;
		if (event.target.nodeName === "INPUT" || event.target.nodeName === "TEXTAREA") {
			columnName = event.target.attributes.columnname.value;
		} else if (event.currentTarget.nodeName === "LI") {
			columnName = event.currentTarget.dataset.columnname;
		}

		console.log(columnName);

		var data = this.state.ContactData;
		data[columnName] = event.target.value;
		if (event.target.type === "checkbox") {
			data[columnName] = event.target.checked;
		}

		this.setState({ ContactData: data });
	};

	onClose() {
		this.setState({ open: false });
		this.props.OnClose && this.props.OnClose();
	}

	render() {
		var baseData = this.state.ContactData;
		var inputProps = { readOnly: false };
		var labelProps = { shrink: true };
		return (
			<Dialog open={this.state.open} onClose={this.onClose} maxWidth="md">
				<DialogTitle>{baseData.contacts_id ? "Edit Contact" : "New Contact"}</DialogTitle>
				<DialogContent>
					<TextField variant="outlined" className="contact-control" onChange={this.dynamicOnChange} inputProps={{ columnName: "first_name" }} label="First Name" value={baseData.first_name} InputProps={inputProps} InputLabelProps={labelProps}></TextField>
					<TextField variant="outlined" className="contact-control" onChange={this.dynamicOnChange} inputProps={{ columnName: "last_name" }} label="Last Name" value={baseData.last_name} InputProps={inputProps} InputLabelProps={labelProps}></TextField>
					<TextField variant="outlined" className="contact-control" onChange={this.dynamicOnChange} inputProps={{ columnName: "phone_number" }} label="Phone Number" value={baseData.phone_number} InputProps={inputProps} InputLabelProps={labelProps}></TextField>
					<TextField variant="outlined" className="contact-control" onChange={this.dynamicOnChange} inputProps={{ columnName: "email" }} label="Email" value={baseData.email} InputProps={inputProps} InputLabelProps={labelProps}></TextField>
					<FormControl variant="outlined" style={{ width: "calc(25% - 20px)", marginRight: "12px", marginTop: "15px" }}>
						<InputLabel id="track-main-label-id">Is Primary?</InputLabel>
						<Select labelWidth={150} inputProps={{ columnname: "is_primary" }} value={baseData.is_primary} onChange={this.dynamicOnChange} labelId="track-maint-label-id">
							<MenuItem data-columnname="is_primary" value={true}>
								Yes
							</MenuItem>
							<MenuItem data-columnname="is_primary" value={false}>
								No
							</MenuItem>
						</Select>
					</FormControl>
					<FormControl variant="standard" component="fieldset" focused={true} style={{ width: "calc(25% - 20px)", marginRight: "12px", marginTop: "15px" }}>
						<InputLabel>Send Maintenance Texts?</InputLabel>
						<Checkbox style={{ width: "5px", marginTop: "5px" }} inputProps={{ columnName: "send_maint_texts" }} checked={baseData.send_maint_texts} onChange={this.dynamicOnChange}></Checkbox>
					</FormControl>
					<FormControl variant="standard" component="fieldset" focused={true} style={{ width: "calc(25% - 20px)", marginRight: "12px", marginTop: "15px" }}>
						<InputLabel>Send Sale Texts?</InputLabel>
						<Checkbox style={{ width: "5px", marginTop: "5px" }} inputProps={{ columnName: "send_sale_texts" }} checked={baseData.send_sale_texts} onChange={this.dynamicOnChange}></Checkbox>
					</FormControl>
					<FormControl variant="standard" component="fieldset" focused={true} style={{ width: "calc(25% - 20px)", marginRight: "12px", marginTop: "15px" }}>
						<InputLabel>Send Repair Texts?</InputLabel>
						<Checkbox style={{ width: "5px", marginTop: "5px" }} inputProps={{ columnName: "send_repair_texts" }} checked={baseData.send_repair_texts} onChange={this.dynamicOnChange}></Checkbox>
					</FormControl>
					<FormControl variant="standard" component="fieldset" focused={true} style={{ width: "calc(25% - 20px)", marginRight: "12px", marginTop: "15px" }}>
						<InputLabel>Send Callback Texts?</InputLabel>
						<Checkbox style={{ width: "5px", marginTop: "5px" }} inputProps={{ columnName: "send_callback_texts" }} checked={baseData.send_callback_texts} onChange={this.dynamicOnChange}></Checkbox>
					</FormControl>
					<FormControl variant="standard" component="fieldset" focused={true} style={{ width: "calc(25% - 20px)", marginRight: "12px", marginTop: "15px" }}>
						<InputLabel>Send Violation Texts?</InputLabel>
						<Checkbox style={{ width: "5px", marginTop: "5px" }} inputProps={{ columnName: "send_violation_texts" }} checked={baseData.send_violation_texts} onChange={this.dynamicOnChange}></Checkbox>
					</FormControl>
					<FormControl variant="standard" component="fieldset" focused={true} style={{ width: "calc(25% - 20px)", marginRight: "12px", marginTop: "15px" }}>
						<InputLabel>Send Nuisance Texts?</InputLabel>
						<Checkbox style={{ width: "5px", marginTop: "5px" }} inputProps={{ columnName: "send_nuisance_texts" }} checked={baseData.send_nuisance_texts} onChange={this.dynamicOnChange}></Checkbox>
					</FormControl>
					<FormControl variant="standard" component="fieldset" focused={true} style={{ width: "calc(25% - 20px)", marginRight: "12px", marginTop: "15px" }}>
						<InputLabel>Send Arrival Texts?</InputLabel>
						<Checkbox style={{ width: "5px", marginTop: "5px" }} inputProps={{ columnName: "send_arrival_texts" }} checked={baseData.send_arrival_texts} onChange={this.dynamicOnChange}></Checkbox>
					</FormControl>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.saveData} color="primary">
						Save
					</Button>
					<Button onClick={this.onClose} color="primary">
						Close
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}
